export default ({ moment }) => {
  const config = {
    number: {
      locale: 'fr-FR',
      currency: 'EUR'
    }
  }

  return {
    date (date) {
      return date ? moment(date).format('LL') : ''
    },
    currency (number) {
      return new Intl.NumberFormat(config.number.locale, {
        style: 'currency',
        currency: config.number.currency
      }).format(number)
    },
    number (number) {
      return new Intl.NumberFormat(config.number.locale).format(number)
    },
    truncated(text, stop, clamp) {
      return text.slice(0, stop) + (stop < text.length ? clamp || ' ...' : '')
    }
  }
}